module.exports = __webpack_public_path__ + "static/media/care.ba147acc.svg";